var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import qs from 'query-string';
import { attempt } from './lib';
/**
 * Given some input NetworkData (either request or response), will parse the
 * body content so it can be recursively scrubbed.
 *
 * - This will attempt to JSON.parse the body.
 * - If that fails, a query string parse it attempted.
 * - If both fail, the body becomes `null`.
 */
export function parse(data) {
    var content = data.body;
    if (content == null) {
        return __assign(__assign({}, data), { body: content });
    }
    var body = attempt(function () { return JSON.parse(content); }) ||
        attempt(function () { return qs.parse(content, { decode: true }); });
    return __assign(__assign({}, data), { body: body });
}
//# sourceMappingURL=parse.js.map